var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "modal-add modal-variable", attrs: { id: _vm.id } },
    [
      _c("div", { staticClass: "modal-title" }, [
        _c("h4", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.dataVariable ? "Edit" : "Add") + " Variable")
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "wrap-content-modal" },
        [
          _c(
            "b-form-group",
            {
              staticClass: "mb-1",
              class: { "error-input": _vm.$v.variable.name.$error }
            },
            [
              _c("label", [_vm._v(" Name ")]),
              _vm._v(" "),
              _c("j-input", {
                attrs: {
                  "error-required": false,
                  placeholder: "Input variable name"
                },
                model: {
                  value: _vm.variable.name,
                  callback: function($$v) {
                    _vm.$set(_vm.variable, "name", $$v)
                  },
                  expression: "variable.name"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            {
              staticClass: "mb-1",
              class: { "error-input": _vm.$v.variable.type.$error }
            },
            [
              _c("label", [_vm._v(" Type ")]),
              _vm._v(" "),
              _c("j-single-select", {
                attrs: {
                  options: _vm.typeOptions,
                  "error-required": false,
                  placeholder: "Select variable type",
                  label: "name"
                },
                model: {
                  value: _vm.variable.type,
                  callback: function($$v) {
                    _vm.$set(_vm.variable, "type", $$v)
                  },
                  expression: "variable.type"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            {
              staticClass: "mb-1",
              class: { "error-input": _vm.$v.variable.value.$error }
            },
            [
              _c("label", [_vm._v(" Value ")]),
              _vm._v(" "),
              _c("j-input", {
                attrs: {
                  "error-required": false,
                  placeholder: "Input variable value"
                },
                model: {
                  value: _vm.variable.value,
                  callback: function($$v) {
                    _vm.$set(_vm.variable, "value", $$v)
                  },
                  expression: "variable.value"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex justify-content-end mt-4" }, [
        _c(
          "button",
          {
            staticClass: "button-border mr-2",
            on: {
              click: function($event) {
                _vm.$emit("close-modal")
              }
            }
          },
          [_vm._v("\n      Close\n    ")]
        ),
        _vm._v(" "),
        _c("button", { staticClass: "button-blue" }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.dataVariable ? "Update" : "Apply") +
              "\n    "
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-db5fdaec", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-db5fdaec","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/application-manager/detail/app-tabs/partials/modal/modalVariable.vue
// module id = null
// module chunks = 